import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { PortalAdminFeatureFlags, ToolAccess } from '../models/user';
import { PermissionService } from '../services/permission.service';
import { Access } from '../models/rbac';

export const permissionGuard: CanActivateFn = route => {
  const routePermission = route.data['permission'] as keyof ToolAccess;
  const routeAction = route.data['action'] as keyof Access;

  return inject(PermissionService).canActivate(routePermission);
};

export const featureFlagGuard: CanActivateFn = route => {
  const featureFlag = route.data['featureFlag'] as keyof PortalAdminFeatureFlags;

  return inject(PermissionService).canActivateFeature(featureFlag);
};
